<template>
  <div>
    <!-- 产品分类导航 start -->
    <div class="sub-product-nav-btn">
      <p @click="showSubHandler(true)" v-if="!subNavFlag">产品推荐</p>
    </div>
    <div class="product-nav" v-if="subNavFlag">
      <div class="bg"></div>
      <div class="product-box">
        <div class="wrap">
          <div class="box">
            <template v-for="(item, idx) in menuNav">
              <div class="item-box" :key="idx" v-if="item.id !== 4">
                <h2>{{item.name}}</h2>
                <div class="list">
                  <template v-for="(child, index) in item.children">
                    <p @click="nodeHandler(child.id, item.id)" :key="index" v-if="index < 10">{{child.name}}</p>
                  </template>
                </div>
              </div>
            </template>
          </div>
          <span @click="showSubHandler(false)" class="close-btn"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ApiWebProjectIndex } from '../api/product'
export default {
  name: 'product',
  data () {
    return {
      subNavFlag: false,
      menuNav: []
    }
  },
  created () {
    this.initProductList()
  },
  methods: {
    /**
     * 查询产品信息
     */
    initProductList () {
      ApiWebProjectIndex().then(({data}) => {
        if (data && data.status === 0) {
          this.menuNav = data.data.menu
        }
      })
    },
    /**
     * 产品案例点击操作
     * id: 产品/案例 id
     * nid: 菜单类型id  1-软件产品、2-硬件产品、3-成功案例、4-解决方案
     */
    nodeHandler (id, nid) {
      if (nid === 1 || nid === 2) {
        this.$store.commit('product/setProductId', id)
        this.$router.push({ name: 'productDetail', params: { productId: id } })
      } else if (nid === 3 || nid === 4) {
        this.$store.commit('product/setProjectId', id)
        this.$router.push({ name: 'productDemo', params: { projectId: id } })
      }
    },
    /**
     * 打开产品推荐导航 操作
     */
    showSubHandler (val) {
      this.subNavFlag = val
      // if (val) this.unScroll()
      // else this.removeUnScroll()
    },
    //禁止滚动条滚动
    unScroll() {
      let mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false)
    },
    //移除禁止滚动条滚动
    removeUnScroll() {
      let mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = ''
      document.addEventListener('touchmove', mo, false)

    }
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
  .product-nav{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 91px;
    left: 0;
    z-index: 999;
    .bg{
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
    }
    .product-box{
      position: absolute;
      height: 719px;
      width: 100%;
      left: 0;
      top: 0;
      background: #ffffff;
      .wrap{
        width: 1552px;
        height: 719px;
        margin: 0 auto;
        position: relative;
        .box{
          width: 1552px;
          height: 719px;
          padding: 80px 0;
          margin: 0 auto;
          .item-box{
            width: 33.33%;
            height: 100%;
            padding: 0 40px;
            float: left;
            h2{
              display: block;
              height: 60px;
              margin-bottom: 16px;
              line-height: 24px;
              font-size: 24px;
              color: #111111;
              text-align: left;
              font-weight: normal;
              border-bottom: 1px solid #99999999;
              &:hover{
                font-weight: bold;
              }
            }
            .list {
              height: 500px;
              width: 100%;
              overflow: hidden;
              p{
                height: 20px;
                line-height: 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-top: 24px;
                font-size: 20px;
                color: #111111;
                text-align: left;
                &:hover{
                  font-weight: bold;
                  text-decoration: underline ;
                  cursor: default;
                }
              }
            }
            .page{
              height: 18px;
              width: 51px;
              margin: 10px 0 20px 0;
              float: right;
              span{
                display: block;
                width: 18px;
                height: 18px;
                float: left;
                background: red;
              
              }
              .pre-btn{
                background: url('~@/assets/img/a_more_left.png') left center no-repeat;
                background-size: 18px auto;
                margin-right: 15px;
              }
              .pre-btn-disable {
                background: url('~@/assets/img/a_more_left2.png') left center no-repeat;
                background-size: 18px auto;
                margin-right: 15px;
              }
              .next-btn{
                background: url('~@/assets/img/a_more.png') left center no-repeat;
                background-size: 18px auto;
              }
              .next-btn-disable{
                background: url('~@/assets/img/a_more3.png') left center no-repeat;
                background-size: 18px auto;
              }
            }
          }
        }
        .close-btn{
          position: absolute;
          bottom: 30px;
          right: 20px;
          display: block;
          width: 20px;
          height: 20px;
          background: url('~@/assets/img/close_btn.png') left center no-repeat;
          background-size: 18px auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/product-sub.vue